export default __webpack_public_path__ + "static/media/Logout.7e94a952.svg";